import type { FaqProps } from "../../design-system/faq"
import { extractText } from "../../utils/text-extraction"

type FaqSchema = {
  "@type": "FAQPage"
  mainEntity: Array<{
    "@type": "Question"
    name: string
    acceptedAnswer: {
      "@type": "Answer"
      text: string
    }
  }>
}

const getAnswerText = (faq: FaqProps): string => {
  if (faq.schemaText) {
    return faq.schemaText
  }

  return extractText(faq.answer)
}

export const generateFaqSchema = (faqs: FaqProps[]): FaqSchema => ({
  "@type": "FAQPage",
  mainEntity: faqs.map(faq => ({
    "@type": "Question",
    name: faq.question,
    acceptedAnswer: {
      "@type": "Answer",
      text: getAnswerText(faq),
    },
  })),
})
